module.exports = __webpack_public_path__ + "img/4.d53fb371.png";